window.PdpLoginRedirect = {
  triggerSelector: '.pdp-login-flow',
  storageKey: 'redirect_after_login',
  registerUrl: '/account/register',

  init() {
    if (this.isAccountPage()) {
      this.handleAccountPage();
    } else {
      this.handleProductPage();
    }
  },

  isAccountPage() {
    return window.location.pathname.startsWith('/account');
  },

  isProductPage() {
    return window.location.pathname.includes('/products/');
  },

  handleProductPage() {
    // if (!this.isProductPage()) return;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(this.triggerSelector);
      if (!trigger) return;

      event.preventDefault();

      this.storeCurrentUrl(trigger);
      this.redirectToRegister();
    });
  },

  handleAccountPage() {
    if(window.customer.isLoggedIn)
      this.redirectBackAfterLogin();

  },

  storeCurrentUrl(trigger) {
    if(trigger.hasAttribute('data-cart-spotlight-trigger')) {
      let redirectUrl = window.location.href + '#opencart';
      sessionStorage.setItem(this.storageKey, redirectUrl);
    } else {
      sessionStorage.setItem(this.storageKey, window.location.href);
    }
  },

  redirectToRegister() {
    window.location.href = this.registerUrl;
  },

  redirectBackAfterLogin() {
    const redirectUrl = sessionStorage.getItem(this.storageKey);
    if (!redirectUrl) return;

    const current = new URL(window.location.href);
    const redirect = new URL(redirectUrl);

    const samePage =
      current.pathname.replace(/\/$/, '') === redirect.pathname.replace(/\/$/, '') &&
      current.search === redirect.search;

    sessionStorage.removeItem(this.storageKey);

    if (!samePage) {
      window.location.href = redirectUrl;
    }
  }
};

document.addEventListener('DOMContentLoaded', function() {    
  window.PdpLoginRedirect.init();
})
